import { render, staticRenderFns } from "./DisplayBankLogo.vue?vue&type=template&id=31bb38fa&scoped=true"
import script from "./DisplayBankLogo.vue?vue&type=script&lang=js"
export * from "./DisplayBankLogo.vue?vue&type=script&lang=js"
import style0 from "./DisplayBankLogo.vue?vue&type=style&index=0&id=31bb38fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb38fa",
  null
  
)

export default component.exports